import { styled, Theme } from '@nexelem/deprecated-theme';
import { ITEM_HEIGHT } from '../../consts';

export const VerticalLine = styled('div')<{
  dependenciesContainerHeight: number;
  depth: number;
}>(({ dependenciesContainerHeight, depth, theme }) => {
  const {
    spacing,
    palette: { getColor },
    client: {
      toDoList: {
        task: { borderAlt },
      },
    },
  } = theme as Theme;

  const borderHeight = dependenciesContainerHeight / 4 - ITEM_HEIGHT / 3;
  const calculatedLeftOffset = 69 + depth * 23;

  return {
    position: 'absolute',
    display: 'block',
    top: spacing(-6.5),
    left: `${calculatedLeftOffset}px`,
    transform: `translate(-0.3px, ${spacing(2.4)})`,
    borderLeft: `${spacing(0.25)} ${getColor(borderAlt)} dashed`,
    height: spacing(borderHeight),
    transition: 'height 200ms ease',
    width: '1px',
  };
});
